import dayjs from "dayjs";

/**
 * Note:
 * For India, some browsers (I tested in ms edge, win 11) return "Asia/Calcutta" as timezone
 * This timezone is invalid when used in MongoDB aggregation pipeline (may also be invalid in other places, need to confirm).
 * Below error occurs when using following in aggregation pipeline $dateToString: {timezone: timeZone}
 *  error: "unrecognized time zone identifier: 'Asia/Calcutta'"
 * 
 * for "timezone" MongoDB also accepts a UTC offset in the form:
 *  +/-[hh]:[mm], e.g. "+04:45", or
 *  +/-[hh][mm], e.g. "-0530", or
 *  +/-[hh], e.g. "+03".
 * 
 * Using Intl API, for timezone string is not safe, instead using timezone offset is more reliable as it is in standard format (ISO 8601).
 * getUserTimeZoneAsString overrides "Asia/Calcutta" to "Asia/Kolkata" for India.
 * There maybe other such cases. So using getUserTimeZoneAsOffset is more reliable.
 */ 
export function getUserTimeZoneAsString() {
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone === "Asia/Calcutta") {
        timeZone = "Asia/Kolkata";
    }
    return timeZone;
}

/**
 * Returns user's timezone as UTC offset in format +/-[hh]:[mm], e.g. "+05:30"
 * This format is accepted by MongoDB timezone field in aggregation pipeline.
 * source: https://www.mongodb.com/docs/manual/reference/operator/aggregation/dateToParts/
 */
export function getUserTimeZoneAsOffset() {
    return dayjs().format("Z");
}